<template>
  <div :class="['base-switch', {'base-switch--disabled': disabled }]">
    <span v-if="label" :id="`${calculatedId}-label`" class="base-switch__label">{{ label }}</span>
    <div
      :class="['base-switch__switch', { 'base-switch__switch--checked': isChecked }]"
      role="switch"
      v-bind="calculatedAttributes"
      :tabindex="disabled ? -1 : 0"
      :aria-disabled="disabled"
      @click="toggleSwitch"
      @keydown.space.prevent="toggleSwitch"
      @keydown.enter.prevent="toggleSwitch">
      <div class="base-switch__handle">
        <oie-base-icon :icon="icon" size="xs"></oie-base-icon>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  inheritAttrs: false,
  props: {
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    icon() {
      return this.isChecked ? 'checkmark' : 'close'
    },
    calculatedAttributes() {
      return {
        'id': this.calculatedId,
        'aria-checked': this.isChecked,
        'aria-labelledby': this.label && `${this.calculatedId}-label`,
        ...this.$attrs
      }
    },
    calculatedId() {
      return this.id || _.uniqueId('base-switch-')
    },
    isChecked: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    toggleSwitch() {
      if(this.disabled) return
      this.$emit('input', !this.isChecked)
    }
  }
}
</script>

<style lang="scss">
.base-switch {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: measure(quarter);
}

.base-switch--disabled {
  opacity: 0.5;
  pointer-events: none;
}

.base-switch__switch {
  width: 50px;
  height: 25px;
  background-color: #ccc;
  border-radius: 25px;
  display: flex;
  align-items: center;
  cursor: pointer;
  outline: none;
  position: relative;
  transition: background-color 0.3s;
}

.base-switch__switch--checked {
  background-color: color(background-green-2);
}

.base-switch__handle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background-color: #fff;
  border-radius: 50%;
  position: absolute;
  left: 2.5px;
  transition: left 0.3s;
}

.base-switch__switch--checked .base-switch__handle {
  left: calc(100% - 22.5px);
}

.base-switch__switch:focus-visible {
  outline: 3px solid color(black);
}
</style>
